import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import Header from './app/Header';
import Footer from './app/Footer';
import FooterCopyright from './app/FooterCopyright';
import PlanCards from './app/PlanCards';
import LeadForm from './app/LeadForm';
import { useLeadSignup } from './app/LeadSignupContext';
import { PLANS, SHARED, FAQS } from './utils/product';

const Precos = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const { openSignup } = useLeadSignup();

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 bg-mesh-light" aria-hidden="true" />
        <div className="relative container mx-auto px-4 lg:px-6 py-16 lg:py-24 text-center max-w-2xl mx-auto">
          <span className="badge-brand mb-5">Fretz Empresas</span>
          <h1 className="font-display text-display-xl text-ink-900">
            Três planos de rota
          </h1>
          <p className="mt-5 text-xl text-ink-500">
            Diário, Semanal ou Mensal. A partir de {SHARED.fromPrice}/mês.
            Mesmas regras de pacote e porta em todos.
          </p>
        </div>
      </section>

      <section className="section bg-ink-50">
        <div className="container mx-auto px-4 lg:px-6">
          <PlanCards />
        </div>
      </section>

      <section className="section bg-white">
        <div className="container mx-auto px-4 lg:px-6">
          <div className="text-center mb-10">
            <p className="eyebrow mb-2">Comparativo</p>
            <h2 className="font-display text-display-lg text-ink-900">Qual escolher?</h2>
          </div>
          <div className="precios-table-container">
            <table className="precios-table">
              <thead>
                <tr>
                  <th> </th>
                  {PLANS.map((p) => (
                    <th key={p.id}>{p.name}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[
                  ['Mensalidade', ...PLANS.map((p) => `${p.priceLabel}${p.priceSuffix}`)],
                  ['Coleta', ...PLANS.map((p) => p.cadence)],
                  ['SLA', ...PLANS.map((p) => p.slaShort)],
                  ['Paradas inclusas', ...PLANS.map((p) => String(p.stops))],
                  ['Parada extra', ...PLANS.map((p) => p.extraStopLabel)],
                  ['Pacote', ...PLANS.map(() => `${SHARED.maxSize} · ${SHARED.maxWeight}`)],
                  ['Espera na porta', ...PLANS.map(() => SHARED.doorWait)],
                  ['Cobertura', ...PLANS.map(() => SHARED.coverage)],
                ].map((row) => (
                  <tr key={row[0]}>
                    {row.map((cell, i) => (
                      <td key={i} className={i === 0 ? 'font-semibold text-ink-900' : ''}>{cell}</td>
                    ))}
                  </tr>
                ))}
                <tr>
                  <td className="font-semibold text-ink-900">Assinar</td>
                  {PLANS.map((p) => (
                    <td key={p.id}>
                      <button
                        type="button"
                        onClick={() => openSignup(p.id)}
                        className={p.highlight ? 'btn-primary w-full' : 'btn-secondary w-full'}
                      >
                        Quero assinar
                      </button>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="section bg-ink-50">
        <div className="container mx-auto px-4 lg:px-6 max-w-2xl">
          <div className="text-center mb-10">
            <p className="eyebrow mb-2">Dúvidas sobre planos</p>
            <h2 className="font-display text-display-lg text-ink-900">FAQ</h2>
          </div>
          <div className="space-y-3">
            {FAQS.map((item, idx) => {
              const isOpen = openFaq === idx;
              return (
                <div key={item.q} className="card overflow-hidden">
                  <button
                    onClick={() => setOpenFaq(isOpen ? null : idx)}
                    className="w-full flex items-center justify-between gap-4 p-5 text-left hover:bg-ink-50 transition"
                  >
                    <span className="font-semibold text-ink-900">{item.q}</span>
                    <ChevronDownIcon className={`h-5 w-5 text-ink-500 shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 text-ink-600 text-sm leading-relaxed fade-up">{item.a}</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container mx-auto px-4 lg:px-6">
          <div className="grid lg:grid-cols-2 gap-10 items-start">
            <div>
              <h2 className="font-display text-display-lg text-ink-900">Pronto para assinar?</h2>
              <p className="mt-3 text-ink-500 text-lg">
                Sem simulador de picape. Fale com a gente e ativamos o plano na Grande Goiânia.
              </p>
              <div className="mt-8">
                <Link to="/como-funciona" className="btn-secondary">Como funciona a rota</Link>
              </div>
            </div>
            <div className="card p-6 lg:p-8">
              <LeadForm />
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FooterCopyright />
    </div>
  );
};

export default Precos;
